// extracted by mini-css-extract-plugin
export var description = "sizing-module--description--a3425";
export var diagram = "sizing-module--diagram--b662c";
export var head = "sizing-module--head--1110f";
export var panel = "sizing-module--panel--4036f";
export var table = "sizing-module--table--ebf81";